'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwatchesColor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _reactAddonsShallowCompare = require('react-addons-shallow-compare');

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SwatchesColor = exports.SwatchesColor = function (_React$Component) {
  _inherits(SwatchesColor, _React$Component);

  function SwatchesColor() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _classCallCheck(this, SwatchesColor);

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SwatchesColor)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleClick = function () {
      _this.props.onClick(_this.props.color);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SwatchesColor, [{
    key: 'render',
    value: function render() {

      var styles = (0, _reactcss2.default)({
        'default': {
          color: {
            width: '40px',
            height: '24px',
            cursor: 'pointer',
            background: this.props.color,
            marginBottom: '1px'
          },
          check: {
            fill: '#fff',
            marginLeft: '8px',
            display: 'none'
          }
        },
        'first': {
          color: {
            overflow: 'hidden',
            borderRadius: '2px 2px 0 0'
          }
        },
        'last': {
          color: {
            overflow: 'hidden',
            borderRadius: '0 0 2px 2px'
          }
        },
        active: {
          check: {
            display: 'block'
          }
        }
      }, this.props);

      return _react2.default.createElement(
        'div',
        { style: styles.color, ref: 'color', onClick: this.handleClick },
        _react2.default.createElement(
          'div',
          { style: styles.check },
          _react2.default.createElement(
            'svg',
            { style: { width: '24px', height: '24px' }, viewBox: '0 0 24 24' },
            _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
          )
        )
      );
    }
  }]);

  return SwatchesColor;
}(_react2.default.Component);

exports.default = SwatchesColor;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-color/lib/components/swatches/SwatchesColor.js
 ** module id = 1518
 ** module chunks = 0
 **/